module.exports = __webpack_public_path__ + "img/crcgas_logo.5287d9d0.png";